/* eslint-disable linebreak-style */
export interface ClientMigration {
    compid: number;
    compname: string;

    cdh_wave_id: number | null;
    cdh_wave_name: string;
    cdh_wave_start_date: string | null;
    cdh_planned_migration_date: string | null;
    cdh_actual_migration_date: string | null;
    cdh_live_date: string | null;
    cdh_migration_status: string | null;

    cobra_wave_id: number | null;
    cobra_wave_name: string;
    cobra_wave_start_date: string | null;
    cobra_planned_migration_date: string | null;
    cobra_actual_migration_date: string | null;
    cobra_live_date: string | null;
    cobra_migration_status: string | null;

    migration_notes: string;
    cdh_wave_notes: string;
    cobra_wave_notes: string;

    has_override: boolean;
    client_status: number;
    created_at: string | null;
    created_by: string | null;
    updated_at: string | null;
    updated_by: string | null;
  }

export interface HasMigrated {
    cobra: boolean;
    cdh: boolean;
  }

export enum MigrationOptions {
  cobraOnly = 1,
  cdhOnly,
  both
}
